<ng-container *ngIf="block">
    <div class="row container-general">
        <div class="col container-general__container-dropdown">
          <div ngbDropdown #myDrop="ngbDropdown" placement="center" class="d-inline-block w-100 bg-white container-general__container-dropdown__ngbdrop">
            <button 
              type="button" 
              class="btn container-general__container-dropdown__ngbdrop__btn-custom b-grey w-100 d-flex justify-content-between align-items-center ls-label-large"
              id="{{ 'dropdown-' + block.id }}" 
              ngbDropdownToggle
              [ngClass]="{'b-success': isValue}"
            >
              {{ titleDropdown }}
              <i class="fa-solid fa-angle-down text-success" aria-hidden="true"></i>
            </button>
            <div 
              class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu"
              ngbDropdownMenu 
              aria-labelledby="{{ 'dropdown-' + block.id }}"
            >
              <div class="d-flex justify-content-between align-items-center container-general__container-dropdown__ngbdrop__ngbDropdownMenu__header">
                <p class="m-0 ls-label-small-bold">{{ block.titolo | uppercase}}</p>
                <div class="cursor-pointer" (click)="$event.stopPropagation(); myDrop.close();">
                  <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                </div>
              </div>
              <form [formGroup]="checkboxGroupForm" class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form">
                <div id="sampleSelectcheckboxGroupForm{{ block.id }}" class="d-flex flex-column justify-content-between container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox">
                  <div class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general">
                    <input *ngIf="block.id === 3" type="search" placeholder="Cerca e premi invio" [formControl]="typeahead" aria-label="Cerca" 
                      class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general__search bg-light" (keyup.enter)="suggest()">
                    <div class="container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general__checkbox-box"

                    >
                      <div class="d-flex align-items-center container-general__container-dropdown__ngbdrop__ngbDropdownMenu__form__body-checkbox__general__checkbox-box__cont-label" 
                        *ngFor="let order of checkArray | async; let i = index">
                        <label class="col-2" formArrayName="checkbox">
                          <input type="checkbox" [formControlName]="i">
                        </label>
                        <p class="m-0 col-10 ls-p">{{order.value}}</p>
                      </div> 
                    </div>
                  </div>
                  <button type="button" class="btn btn-success w-100 btn-submit" (click)="submit(); $event.stopPropagation(); myDrop.close();">{{"CONFIRM" | translate}}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
    </div>
</ng-container>
